<app-page>
  <ng-template #mainTpl>
    <ng-container *ngIf="desktop | async" >
      <div class="section_2">
        <div class="section-card">
          <div class="card-top">
            <h2 class="card-title">
              <ng-container i18n>By backpackers, for hostels</ng-container>
            </h2>
            <div class="card-content">
              <ng-container i18n>Hostel Hop charges a lower booking fee to hostels, helping travelers to save even more. Join us today and learn how our platform can boost your hostel's bookings.</ng-container>
            </div>
          </div>
          <div>
            <a class="btn btn-theme btn-large btn-icon" href="https://admin.hostelhop.io" target="_blank">
              <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/building.svg"></svg-icon>
              <span>List your property</span>
            </a>
          </div>
        </div>
        <div class="img-container">
          <div class="section_2-img">
            <img ngOptimizedImage [ngSrc]="'../../assets/images/HostelHop_Silhouette.webp'" [fill]="true" alt="for backpackers by hostels">
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!(desktop | async)" >
      <div class="section_2-sm">
        <div class="section-card">
          <div class="card-top">
            <h2 class="card-title">
              <ng-container i18n>By backpackers, for hostels</ng-container>
            </h2>
            <div class="card-content">
              <ng-container i18n>Hostel Hop charges a lower booking fee to hostels, helping travelers to save even more. Join us today and learn how our platform can boost your hostel's bookings.</ng-container>
            </div>
          </div>
          <div class="button-wrapper">
            <a class="btn btn-theme btn-large btn-icon" href="https://admin.hostelhop.io" target="_blank">
              <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/building.svg"></svg-icon>
              <ng-container i18n>List your property</ng-container>
            </a>
          </div>
        </div>
        <div class="img-container">
          <div class="section_2-img">
            <img ngOptimizedImage [ngSrc]="'../../assets/images/HostelHop_Silhouette.webp'" [fill]="true" alt="for backpacers by hostels">
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>
</app-page>
